import React from 'react';
import { Card } from '@theme-ui/components';
import { GatsbyImage } from 'gatsby-plugin-image';

const SocialCard = ({ image, alt, title }) => (
  <Card variant="primary" className='social-card'>
    <GatsbyImage
      image={image.gatsbyImageData}
      imgStyle={{ width: '100%', height: '100%', objectFit: 'contain' }}
      alt={alt}
      title={title}
    />
  </Card>
);

export default SocialCard;
